import React from 'react';
import cn from 'classnames';
import { bool, number, string } from 'prop-types';
import { designTokenPropTypes } from '@immediate_media/design-tokens';
import Icon from '../../atoms/Icon';
/**
 * LoadingIcon component.
 */

var LoadingIcon = function LoadingIcon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      color = _ref.color,
      fadeOut = _ref.fadeOut;
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": fadeOut ? 'true' : null,
    className: cn('loading-icon', className, fadeOut && 'loading-icon--fade-out'),
    tabIndex: fadeOut ? -1 : null
  }, /*#__PURE__*/React.createElement(Icon, {
    spinning: true,
    color: color,
    animationDuration: 1000,
    name: "loading",
    srOnly: "Loading",
    size: size
  }));
};

LoadingIcon.defaultProps = {
  className: null,
  size: 80,
  color: 'backgroundDark',
  fadeOut: false
};
LoadingIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** The size of the loading icon. */
  size: number,

  /** The icon color. */
  color: designTokenPropTypes.color,

  /** Fade out the icon. */
  fadeOut: bool
} : {};
export default LoadingIcon;